<template>
  <div class="ex-item">
    <div v-if="exLoading" style="text-align:center;line-height:500px;">Loading...</div>
    <div class="ex-item-wrap" @click="goDetails(item)" v-if="exList && exList.length > 0"
      v-for="(item, index) in exList" :key="'ex-wrap-' + index">
      <div class="wrap-t">
        <img v-if="item.logo" :src="item.logo" />
        <img src="@assets/img/empty.png" v-else>
        <p v-if="item.nameEn" :title="item.nameEn" style='display: flex;align-items: center;'><span style="max-width: 260px;overflow: hidden;">{{ item.nameEn }}</span></p>
        <p v-else :title="item.nameEn" style='display: flex;align-items: center;'><span style="max-width: 260px;overflow: hidden;">{{ item.name }}</span></p>
        <!-- <p v-if="item.nameEn" :title="item.nameEn" style='display: flex;align-items: center;'><span style="max-width: 260px;overflow: hidden;">{{ item.nameEn }}</span> <img @click.stop="daolan(item)" src="@assets/img/daolan.svg" alt="" style="width:22px;margin-left:10px;cursor:pointer;"></p>
        <p v-else :title="item.nameEn" style='display: flex;align-items: center;'><span style="max-width: 260px;overflow: hidden;">{{ item.name }}</span> <img @click.stop="daolan(item)" src="@assets/img/daolan.svg" alt="" style="width:22px;margin-left:10px;cursor:pointer;"></p> -->
        <div class="wrap-t-line search-pc"></div>
        <div class="wrap-t-imgbox" v-if="item.listProduct && item.listProduct.length > 0"
          :class="item.listProduct.length == 2 ? 'imgboxTwo' : ''">
          <img v-for="(itm, idx) in item.listProduct" :key="idx" v-if="itm.banner[0] && idx < 3" :src="itm.banner[0]" />
        </div>
      </div>
      <div class="wrap-b">
        <div>
          <i class="icon iconfont icon-dizhi" v-if="item.province || item.city"></i>
          <span v-if="item.province">{{ item.province }}</span>
          &nbsp;<span v-if="item.city">·</span>
          &nbsp;<span v-if="item.city">{{ item.city }}</span>
          &nbsp;&nbsp;<span v-if="item.listBoothInfo.length > 0 && item.listBoothInfo[0].isShowBoothInfo">Booth
            Number:{{ item.boothInfo[0].Hall }}-{{ item.boothInfo[0].Code }}</span>
        </div>
        <!-- <i style="color:#b1262d;" class="icon iconfont icon-love"></i> -->
        <i style="color:#b1262d;" class="icon iconfont icon-love" @click.stop="cancelCollect(item)"
          v-if="item.isFollow"></i>
        <i style="color:#bfbfbf;" class="icon iconfont icon-guanzhu-xian" @click.stop="addCollect(item)" v-else></i>
      </div>
    </div>
    <div v-if="!exLoading && exList && exList.length == 0" style="line-height:500px;text-align:center;">
      No Data
    </div>
    <div class="m-page" v-if="totalCount > pageSize">
      <Page show-total show-elevator :page-size="pageSize" :current="pageIndex" :total="totalCount"
        @on-change="changePage" @on-page-size-change="changePageSize" show-sizer />
    </div>

    <gLogin :show="show" @close="show = false;" />
  </div>
</template>

<script>
import gLogin from "@components/En/gLogin/gLogin.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "ex-item",
  props: {
    exList: {
      type: Array,
      default: []
    },
    pageIndex: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    totalCount: {
      type: Number,
      default: 0
    },
    exLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
    };
  },
  components: {
    gLogin
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      exhibiton: "loginModule/getExhibition"
    }),
    opt() {
      return {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        totalCount: this.totalCount
      }
    },
  },
  methods: {
    daolan(item) {
        if(item.boothInfo.length<=0 || !item.boothInfo){
            this.$Message.warning("暂无展厅信息")
            return
        }
    let boothNum=item.boothInfo[0].Code;
      let url = `https://plan.shuzihuizhan.com/boothplan?exhibitionId=08dd5084-f3c0-477e-8733-f22f034f398a&lang=en&boothNum=${boothNum}&nav=1`;
      window.open(url, "_blank");
    },
    changePage(e) {
      this.opt.pageIndex = e;
      this.$emit("getExList", this.opt);
    },
    changePageSize(e) {
      this.opt.pageSize = e;
      this.$emit("getExList", this.opt);
    },
    goDetails(item) {
      const url = location.origin + `/ex-detailsEn/${item.joinId}?compId=${item.compId}&exhibitionId=${item.exhibitionId}`;
      window.open(url, "_blank");
      // this.$router.push(`/ex-details/${item.joinId}?compId=${item.compId}`);
    },
    addCollect(item) {
      if (!this.user) {
        this.show = true;
        this.$Message.warning("请登录后关注");
        return;
      }
      let body = {
        "userId": this.user.userId,
        "compId": item.compId,
      }
      this.$http.post('/api/Follower', body, this.$store.state.header)
        .then(res => {
          if (res.status === 200 && res.data.successed) {
            this.$emit('addsuccess', item)
          } else {
            this.$Message.error("关注失败，请重新尝试");
          }
        })
    },
    cancelCollect(item) {
      if (!this.user) {
        this.$Message.warning("请登录后操作");
        this.show = true;
        return;
      }
      let body = {
        "userId": this.user.userId,
        "compId": item.compId,
      }
      this.$http.put('/api/Follower/UnFollow', body, this.$store.state.header)
        .then(res => {
          if (res.status === 200 && res.data.successed) {
            this.$emit('cancelsuccess', item)
          } else {
            this.$Message.error("取消失败，请重新尝试");
          }
        })

    }
  }
};
</script>

<style scoped lang='scss'>
@media (min-width: 799px) {
  .search-pc {
    display: none !important;
  }

  .search-mobile {
    display: block !important;
  }

  .ex-item {
    background-color: #fff;
    padding: 20px;
    margin-bottom: 50px;

    &-wrap {
      width: 100%;
      height: 150px;
      padding-top: 20px;
      margin-bottom: 20px;
      background-color: #f5f5f5;
      cursor: pointer;
      transition: 0.2s;

      &:hover {
        transform: scale(1.1);
      }

      .wrap-t {
        display: flex;
        align-items: center;
        width: 100%;
        height: 87px;
        padding: 0 0 0 20px;

        img {
          width: 74px;
          height: 74px;
          border-radius: 50%;
        }

        p {
          margin: 0 10px 0 10px;
          width: 270px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        &-line {
          width: 2px;
          height: 80px;
          background-color: #e6e6e6;
        }

        &-imgbox {
          width: 490px;
          padding-left: 40px;
          display: flex;
          align-items: center;

          img {
            width: 130px;
            height: 87px;
            border-radius: 0;
            margin-right: 20px;
          }
        }
      }

      .wrap-b {
        display: flex;
        justify-content: space-between;
        height: 43px;
        align-items: center;
        padding: 0 20px;

        div {
          color: #333;
          font-size: 12px;
          display: flex;
          align-items: center;
          height: 100%;

          i {
            font-size: 22px;
            color: #999;
          }
        }

        i {
          font-size: 30px;
        }
      }
    }

    .m-page {
      width: 100%;
      padding: 20px 0;
      text-align: center;
    }
  }
}

@media (max-width: 799px) {
  .search-pc {
    display: none !important;
  }

  .search-mobile {
    display: block !important;
  }

  .ex-item {
    background-color: #fff;
    padding: 0 calc(30vw/7.5);

    // margin-bottom: 50px;
    &-wrap {
      width: 100%;
      padding: calc(30vw/7.5);
      margin-bottom: 20px;
      background-color: #f7f7f7;
      border-radius: calc(10vw/7.5);

      .wrap-t {
        width: 100%;

        img {
          width: calc(100vw/7.5);
          height: calc(100vw/7.5);
          border-radius: 50%;
        }

        p {
          line-height: calc(100vw/7.5);
          margin: 0 10px 0 10px;
          width: calc(490vw/7.5);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: inline-block;
          font-family: PingFang-SC-Medium;
          font-size: calc(30vw/7.5);
          font-weight: Medium;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #333333;
        }

        &-line {
          width: 2px;
          height: 80px;
          background-color: #e6e6e6;
        }

        &-imgbox {
          width: 100%;
          display: flex;
          justify-content: space-between;
          margin: calc(30vw/7.5) 0 0;

          img {
            width: calc(190vw/7.5);
            height: calc(128vw/7.5);
            border-radius: 0;
          }
        }

        .imgboxTwo::after {
          content: "";
          width: calc(190vw/7.5);
        }
      }

      .wrap-b {
        display: flex;
        justify-content: space-between;
        height: calc(28vw/7.5);
        align-items: center;
        margin-top: calc(30vw/7.5);

        div {
          color: #333;
          font-family: PingFang-SC-Regular;
          font-size: calc(22vw/7.5);
          display: flex;
          align-items: center;
          height: 100%;

          i {
            font-size: 22px;
            color: #999;
          }
        }

        i {
          font-size: 30px;
        }
      }
    }

    .m-page {
      width: 100%;
      padding: 10px 0 40px;
      text-align: center;
    }
  }

}
</style>
<style lang="scss">
.ivu-message {
  z-index: 1050 !important;
}

@media (max-width: 799px) {
  .ivu-page-options {
    margin-top: calc(20vw/7.5) !important;
  }

  .ivu-page-next {
    margin-top: calc(20vw/7.5) !important;
  }

  .ivu-page-item {
    margin-top: calc(20vw/7.5) !important;
  }

  .ivu-page-total {
    // margin-top: calc(20vw/7.5) !important;
    // height: 42px;
    // line-height: 42px !important;
    vertical-align: middle
  }

  .ivu-page-prev {
    margin-top: calc(20vw/7.5) !important;
  }
}
</style>
